// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://czrjcndncumiltdjrdbu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN6cmpjbmRuY3VtaWx0ZGpyZGJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE4NTU2MDksImV4cCI6MjA4NzQzMTYwOX0.bJM7B1dBvOztc0gRMSYBXKN9viMRurWeu5ffIk7WmbE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});